import { Charts } from './Charts';
import CallsChartsDataProvider from './contexts/CallsChartsDataContext';

const CallsWrapper = () => {
    return (
        <CallsChartsDataProvider>
            <Charts />
        </CallsChartsDataProvider>
    );
};

export default CallsWrapper;
